import { ToastMessage } from '@/ui-kit/components/toast/enums';
import ToastService from '@/components/toast/toast-service';
import SearchApiService from '@/services/api/serverless/search';
import ListingsMapper from '../mappers/ListingsMapper';

const NO_CURRENT_USER_AWS_ERROR = 'No current user';

const FetchSoldData = {
  data() {
    return {
      justContentLoaded: false,
      contentLoading: false,
      listings: [],
    };
  },
  methods: {
    async loadSoldData(requestQuery) {
      this.contentLoading = true;

      try {
        const { data = [] } = await this.fetchSoldData(requestQuery);

        this.listings = ListingsMapper.mapListingsData(data || []);

        if (!this.listings?.length) {
          ToastService.openNegative(ToastMessage.NoResultFound);
        }
      } catch (error) {
        ToastService.openNegative(error.message);
      }

      this.contentLoading = false;
    },
    fetchSoldData(params) {
      return SearchApiService.searchSoldListings(params).catch((error) => {
        if (error === NO_CURRENT_USER_AWS_ERROR) {
          throw new Error(ToastMessage.SoldInformationAccessFail);
        }

        return ({});
      });
    },
    resetSoldData() {
      this.listings = this.listings.length ? [] : this.listings;
    },
    handleListingsLoad() {},
  },
};

export default FetchSoldData;
